// Complete menu data for Scoops&Co with allergen codes.
//
// Allergen codes (Legende):
//   A = Glutenhaltiges Getreide
//   C = Eier
//   D = Fisch
//   E = Erdnüsse
//   F = Soja
//   G = Milch / Laktose
//   H = Schalenfrüchte (Nüsse)
//
// Hinweis (Cross-Kontamination): Alle Produkte können Spuren von Gluten, Ei,
// Milch, Soja, Erdnüssen und Schalenfrüchten enthalten, da sie in derselben
// Produktionsumgebung verarbeitet werden.

export const allergenLegend = {
  A: "Glutenhaltiges Getreide",
  C: "Eier",
  D: "Fisch",
  E: "Erdnüsse",
  F: "Soja",
  G: "Milch / Laktose",
  H: "Schalenfrüchte (Nüsse)",
};

export const allergenDisclaimer =
  "Alle Produkte können Spuren von Gluten, Ei, Milch, Soja, Erdnüssen und Schalenfrüchten enthalten, da sie in derselben Produktionsumgebung verarbeitet werden.";

// Drinks-Hinweis: bei klassischer Zubereitung mit Milch sind alle Drinks G.
const DRINK_NOTE =
  "Standard-Zubereitung mit Milch (G). Pflanzliche Alternativen (Hafer, Soja*, Kokos) auf Anfrage. *F";

export const menuCategories = [
  // ---------------------------------------------------------------------------
  // MONTHLY SPECIAL
  // ---------------------------------------------------------------------------
  {
    id: "monthly-special",
    title: "Monthly Special",
    tagline: "Unser wechselndes Highlight des Monats.",
    image:
      "https://images.pexels.com/photos/11094181/pexels-photo-11094181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Iced Passion Fruit Matcha",
        price: "7,50 €",
        allergens: ["G"],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // EIS
  // ---------------------------------------------------------------------------
  {
    id: "eis",
    title: "Eis",
    tagline: "Italienisches Eis – 1,50 € pro Kugel.",
    image:
      "https://images.unsplash.com/photo-1559622214-f8a9850965bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpY2UlMjBjcmVhbSUyMHNhbmR3aWNofGVufDB8fHx8MTc3OTc1NDM5OXww&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Vanille", price: "1,50 €", allergens: ["C", "G"] },
      { name: "Schokolade", price: "1,50 €", allergens: ["G", "F"] },
      { name: "Erdbeere", price: "1,50 €", allergens: ["G"] },
      { name: "Stracciatella", price: "1,50 €", allergens: ["G", "F"] },
      { name: "Cookies", price: "1,50 €", allergens: ["A", "C", "G", "F"] },
      { name: "Haselnuss", price: "1,50 €", allergens: ["G", "H"] },
      { name: "Pistazie", price: "1,50 €", allergens: ["G", "H"] },
      { name: "Schlumpf", price: "1,50 €", allergens: ["G"] },
      { name: "Amarena", price: "1,50 €", allergens: ["G"] },
      { name: "Joghurt", price: "1,50 €", allergens: ["G"] },
      { name: "Mango", price: "1,50 €", allergens: [] },
      { name: "Zitrone", price: "1,50 €", allergens: [] },
      { name: "Salzkaramell", price: "1,50 €", allergens: ["G"] },
      { name: "Nocciolata", price: "1,50 €", allergens: ["G", "H", "F"] },
      { name: "Himbeere", price: "1,50 €", allergens: [] },
      { name: "Tiramisu", price: "1,50 €", allergens: ["A", "C", "G"] },
      { name: "Melone", price: "1,50 €", allergens: [] },
      { name: "Zartbitter", price: "1,50 €", allergens: ["F", "G"] },
    ],
  },

  // ---------------------------------------------------------------------------
  // COOKIES
  // ---------------------------------------------------------------------------
  {
    id: "cookies",
    title: "Cookies",
    tagline: "Freshly baked · soft centered · handcrafted.",
    image:
      "https://images.pexels.com/photos/28857440/pexels-photo-28857440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Loaded Cookie 100g",
        price: "4,50 €",
        allergens: ["A", "C", "G"],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // BROWNIES
  // ---------------------------------------------------------------------------
  {
    id: "brownies",
    title: "Brownies",
    tagline: "Fudgy · schokoladig · unwiderstehlich.",
    image:
      "https://images.pexels.com/photos/28857440/pexels-photo-28857440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Brownie",
        price: "3,50 €",
        allergens: ["A", "C", "G"],
      },
      {
        name: "Brownie x Ice Cream",
        price: "5,00 €",
        description: "Saftiger Brownie mit einer Kugel Eis deiner Wahl.",
        allergens: ["A", "C", "G"],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // CAKES
  // ---------------------------------------------------------------------------
  {
    id: "cakes",
    title: "Cakes",
    tagline: "Hausgemachte Kuchen – cremig und unwiderstehlich.",
    image:
      "https://images.pexels.com/photos/28857440/pexels-photo-28857440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Oreo Cheesecake",
        price: "4,20 €",
        allergens: ["A", "C", "G", "F"],
      },
      {
        name: "Lotus Cheesecake",
        price: "4,20 €",
        allergens: ["A", "C", "G", "F"],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // ICE CREAM COOKIE SANDWICHES
  // ---------------------------------------------------------------------------
  {
    id: "cookie-sandwiches",
    title: "Ice Cream Cookie Sandwiches",
    tagline: "Indulgent · craveable · instagrammable.",
    image:
      "https://images.unsplash.com/photo-1559622214-f8a9850965bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpY2UlMjBjcmVhbSUyMHNhbmR3aWNofGVufDB8fHx8MTc3OTc1NDM5OXww&ixlib=rb-4.1.0&q=85",
    items: [
      {
        name: "Make Your Own — Loaded",
        price: "7,50 €",
        description: "Wähle deinen Loaded Cookie + eine Kugel Eis.",
        allergens: ["A", "C", "G"],
      },
      {
        name: "Cookie & Scoop",
        price: "6,00 €",
        allergens: ["A", "C", "G"],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // MATCHA
  // ---------------------------------------------------------------------------
  {
    id: "matcha",
    title: "Matcha",
    tagline: "Zeremonieller Matcha, kreativ interpretiert.",
    image:
      "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBtYXRjaGElMjBsYXR0ZXxlbnwwfHx8fDE3Nzk3NTQzOTl8MA&ixlib=rb-4.1.0&q=85",
    drinkNote:
      "Standard-Zubereitung mit Milch (G). Pflanzliche Alternativen (Hafer, Soja*, Kokos) auf Anfrage. *F · Extra Sirup +0,50 €.",
    items: [
      { name: "Matcha Latte Hot", price: "4,50 €", allergens: ["G"] },
      { name: "Strawberry Matcha", price: "7,00 €", allergens: ["G"] },
      { name: "Mango Matcha", price: "7,00 €", allergens: ["G"] },
      { name: "Blackcurrant Matcha", price: "7,00 €", allergens: ["G"] },
      { name: "Banana Pudding Matcha", price: "8,00 €", allergens: ["G"] },
      { name: "Ube Matcha Latte", price: "7,50 €", allergens: ["G"] },
      { name: "Matcha Latte & Icecream Scoop", price: "8,00 €", allergens: ["G"] },
      { name: "Matcha Latte Fruit & Icecream", price: "8,50 €", allergens: ["G"] },
      { name: "Matcha Lime Soda", price: "6,50 €", allergens: [] },
      { name: "Lucky Charms Matcha", price: "8,50 €", allergens: ["A", "G"] },
      { name: "Lion Cereal Matcha", price: "8,00 €", allergens: ["A", "G"] },
      { name: "Nesquick Matcha", price: "8,00 €", allergens: ["G", "F"] },
      { name: "Iced Latte Matcha x Coffee", price: "8,00 €", allergens: ["G"] },
      { name: "Gold Matcha", price: "99,99 €", allergens: ["G"] },
    ],
  },

  // ---------------------------------------------------------------------------
  // HOJICHA
  // ---------------------------------------------------------------------------
  {
    id: "hojicha",
    title: "Hojicha",
    tagline: "Geröstet, nussig, samtig.",
    image:
      "https://images.pexels.com/photos/8736379/pexels-photo-8736379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    drinkNote: DRINK_NOTE,
    items: [
      { name: "Hojicha Latte", price: "5,00 €", allergens: ["G"] },
      { name: "Coconut Vanilla Hojicha", price: "6,00 €", allergens: ["G"] },
      { name: "Strawberry Cloud Hojicha", price: "6,00 €", allergens: ["G"] },
      { name: "Hojicha Vanilla Drop", price: "6,00 €", allergens: ["G"] },
      { name: "Hojicha x Icecream", price: "6,50 €", allergens: ["G"] },
    ],
  },

  // ---------------------------------------------------------------------------
  // CLOUD DRINKS
  // ---------------------------------------------------------------------------
  {
    id: "cloud-drinks",
    title: "Cloud Drinks",
    tagline: "Luftig-leichte Wolken auf samtigem Schaum.",
    image:
      "https://images.unsplash.com/photo-1559622214-f8a9850965bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpY2UlMjBjcmVhbSUyMHNhbmR3aWNofGVufDB8fHx8MTc3OTc1NDM5OXww&ixlib=rb-4.1.0&q=85",
    drinkNote: DRINK_NOTE,
    items: [
      { name: "Strawberry Cloud", price: "7,00 €", allergens: ["G"] },
      { name: "Ube Cloud", price: "7,50 €", allergens: ["G"] },
      { name: "Matcha Cloud", price: "7,50 €", allergens: ["G"] },
      { name: "Coconut Spirulina Cloud", price: "7,00 €", allergens: ["G"] },
    ],
  },

  // ---------------------------------------------------------------------------
  // ICED LATTES
  // ---------------------------------------------------------------------------
  {
    id: "iced-lattes",
    title: "Iced Lattes",
    tagline: "Eiskalt gebraut. Pure Indulgenz.",
    image:
      "https://images.pexels.com/photos/8736379/pexels-photo-8736379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    drinkNote: DRINK_NOTE,
    items: [
      { name: "Lotus Latte", price: "6,50 €", allergens: ["A", "F", "G"] },
      { name: "Caramel Latte", price: "6,50 €", allergens: ["G"] },
      { name: "Iced Latte", price: "5,50 €", allergens: ["G"] },
      { name: "Iced Banana Latte", price: "6,50 €", allergens: ["G"] },
      { name: "Iced Americano", price: "4,50 €", allergens: [] },
    ],
  },

  // ---------------------------------------------------------------------------
  // COFFEE
  // ---------------------------------------------------------------------------
  {
    id: "coffee",
    title: "Coffee",
    tagline: "Specialty Beans, italienisches Handwerk.",
    image:
      "https://images.pexels.com/photos/8736379/pexels-photo-8736379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    drinkNote: DRINK_NOTE,
    items: [
      { name: "Espresso", price: "2,50 €", allergens: [] },
      { name: "Espresso Doppio", price: "3,30 €", allergens: [] },
      { name: "Espresso Macchiato", price: "3,00 €", allergens: ["G"] },
      { name: "Fredo Espresso", price: "3,50 €", allergens: [] },
      { name: "Fredo Cappuccino", price: "4,00 €", allergens: ["G"] },
      { name: "Café Crema", price: "3,80 €", allergens: [] },
      { name: "Cappuccino", price: "3,50 €", allergens: ["G"] },
      { name: "Flat White", price: "3,80 €", allergens: ["G"] },
      { name: "Cafe Latte", price: "3,80 €", allergens: ["G"] },
      { name: "Latte Macchiato", price: "3,80 €", allergens: ["G"] },
      { name: "Cortado", price: "3,60 €", allergens: ["G"] },
      { name: "Americano", price: "3,00 €", allergens: [] },
      { name: "Iced Latte", price: "5,50 €", allergens: ["G"] },
    ],
  },

  // ---------------------------------------------------------------------------
  // REFRESHERS
  // ---------------------------------------------------------------------------
  {
    id: "refreshers",
    title: "Refreshers",
    tagline: "Frische Drinks für heiße Tage.",
    image:
      "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBtYXRjaGElMjBsYXR0ZXxlbnwwfHx8fDE3Nzk3NTQzOTl8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Pink Lemonade", price: "5,50 €", allergens: [] },
      { name: "Strawberry Lychee Soda", price: "5,50 €", allergens: [] },
      { name: "Matcha Lime Soda", price: "5,50 €", allergens: [] },
      { name: "Peach Soda", price: "5,50 €", allergens: [] },
      { name: "Dragonfruit Punch", price: "5,50 €", allergens: [] },
    ],
  },

  // ---------------------------------------------------------------------------
  // AÇAÍ BOWLS
  // ---------------------------------------------------------------------------
  {
    id: "acai",
    title: "Açaí Bowls",
    tagline: "Drei Signature-Bowls oder ganz nach deinem Geschmack. Einheitsgröße 450 ml.",
    image:
      "https://images.pexels.com/photos/11094181/pexels-photo-11094181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Tropical",
        price: "11,90 €",
        description:
          "Cashew-Creme · Mango Püree · Chia Pudding · Granola · Goji Beeren · Brombeeren · Erdbeeren · Kiwi",
        allergens: ["A", "H"],
      },
      {
        name: "Scoops Favorite",
        price: "11,90 €",
        description:
          "Erdnussbutter · Chia Pudding · Yogurt · Granola · Kondensmilch · Kakaonibs · Erdbeeren · Banane · Blaubeeren",
        allergens: ["A", "E", "G"],
      },
      {
        name: "Perfect Pistachio",
        price: "12,50 €",
        description:
          "Pistaziencreme · Vanille Yogurt · Kondensmilch · Schoko Granola · Himbeeren · Pistazien · Kakaonibs",
        allergens: ["A", "G", "H"],
      },
      {
        name: "Mini Scoops Favorite",
        price: "7,90 €",
        description: "Mini-Variante unseres Klassikers.",
        allergens: ["A", "E", "G"],
      },
      {
        name: "Mini Tropical",
        price: "7,90 €",
        description: "Mini-Variante tropisch.",
        allergens: ["A", "H"],
      },
      {
        name: "Mini Perfect Pistachio",
        price: "8,40 €",
        description: "Mini-Variante mit Pistazie.",
        allergens: ["A", "G", "H"],
      },
      {
        name: "Mini Make Your Own",
        price: "8,90 €",
        description:
          "Kleinere Bowl · Wähle deine Lieblings-Toppings (siehe unten).",
        allergens: [],
      },
      {
        name: "Make Your Own",
        price: "13,00 €",
        description:
          "Wähle deine Lieblings-Toppings · Bowl 450 ml · alkoholfrei.",
        allergens: [],
        toppingGroups: [
          {
            label: "Cremes",
            items: [
              { name: "Erdnussbutter", allergens: ["E"] },
              { name: "Haselnuss-Creme", allergens: ["G", "H"] },
              { name: "Pistachio-Creme", allergens: ["G", "H"] },
              { name: "Mandel-Creme", allergens: ["H"] },
              { name: "Lotus-Creme", allergens: ["A", "F"] },
              { name: "Raffaello-Creme", allergens: ["G", "H"] },
              { name: "Nutella", allergens: ["G", "H", "F"] },
            ],
          },
          {
            label: "Dairy",
            items: [
              { name: "Kondensmilch", allergens: ["G"] },
              { name: "Natur Yogurt", allergens: ["G"] },
              { name: "Vanille Yogurt", allergens: ["G"] },
              { name: "Whey Protein Powder Schokolade", allergens: ["G"] },
              { name: "Whey Protein Powder Vanille", allergens: ["G"] },
              { name: "Milchpulver", allergens: ["G"] },
            ],
          },
          {
            label: "Nüsse",
            items: [
              { name: "Erdnuss", allergens: ["E"] },
              { name: "Haselnuss", allergens: ["H"] },
              { name: "Cashew", allergens: ["H"] },
              { name: "Pistachio", allergens: ["H"] },
              { name: "Mandel", allergens: ["H"] },
            ],
          },
          {
            label: "Seeds & Puddings",
            items: [
              { name: "Chia-Pudding", allergens: [] },
              { name: "Matcha Chia Pudding", allergens: [] },
              { name: "Chia Samen", allergens: [] },
            ],
          },
          {
            label: "Früchte",
            items: [
              { name: "Banane", allergens: [] },
              { name: "Blaubeere", allergens: [] },
              { name: "Himbeere", allergens: [] },
              { name: "Erdbeere", allergens: [] },
              { name: "Kiwi", allergens: [] },
              { name: "Goji Beere", allergens: [] },
              { name: "Cocos Chips", allergens: [] },
            ],
          },
          {
            label: "Püree & Saucen",
            items: [
              { name: "Erdbeerpüree", allergens: [] },
              { name: "Mangopüree", allergens: [] },
              { name: "Schokosauce", allergens: ["G", "F"] },
              { name: "Honig", allergens: [] },
            ],
          },
          {
            label: "Crunch",
            items: [
              { name: "Basic Granola", allergens: ["A"] },
              { name: "Schoko Granola", allergens: ["A", "G"] },
              { name: "Nuss Granola", allergens: ["A", "H"] },
              { name: "Haferflocken", allergens: ["A"] },
              { name: "Kakao Nibs", allergens: [] },
            ],
          },
        ],
      },
    ],
  },

  // ---------------------------------------------------------------------------
  // GRANOLA
  // ---------------------------------------------------------------------------
  {
    id: "granola",
    title: "Granola",
    tagline: "Hausgemachtes Granola – knusprig, ehrlich, gut.",
    image:
      "https://images.pexels.com/photos/11094181/pexels-photo-11094181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      {
        name: "Hausgemachtes Granola",
        price: "10,00 €",
        description: "200 g · zum Mitnehmen",
        allergens: ["A"],
      },
    ],
  },
];

export const cafeInfo = {
  name: "Scoops&Co",
  slogan: "Made to Crave",
  address: {
    street: "Chlodwigplatz 13",
    zip: "50678",
    city: "Köln",
    full: "Chlodwigplatz 13, 50678 Köln",
  },
  phone: "+49 174 3135678",
  phoneHref: "tel:+491743135678",
  email: "info@scoopsandco.com",
  hours: [
    { day: "Montag – Donnerstag", time: "11:00 – 22:00" },
    { day: "Freitag – Samstag", time: "11:00 – 23:00" },
    { day: "Sonntag", time: "12:00 – 22:00" },
  ],
  socials: {
    instagram:
      "https://www.instagram.com/scoopsandco?igsh=MXA3d3MybHMzd3J2Zg%3D%3D&utm_source=qr",
    tiktok:
      "https://www.tiktok.com/@scoopsandco?_r=1&_t=ZG-96fXFFxYsPw",
  },
  googleMaps: "https://share.google/pAhoMYHfxdVfp0L0K",
  osmEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=6.9540%2C50.9230%2C6.9620%2C50.9290&layer=mapnik&marker=50.9260%2C6.9580",
  osmLink:
    "https://www.openstreetmap.org/?mlat=50.9260&mlon=6.9580#map=17/50.9260/6.9580",
  imprint: {
    owner: "Haci Bayram Karatas",
    address: "Chlodwigplatz 13, 50678 Köln",
    vatId: "214/5106/6685",
    email: "info@scoopsandco.com",
    phone: "+49 174 3135678",
  },
};
